import { darken } from '@mui/material'
import { Button, Card } from 'reactstrap'
import styled from 'styled-components'

export const Titulo = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
`

interface CardProps {
  isActive?: boolean
}

export const CardColunaPipeline = styled(Card)<CardProps>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: #00ab4f0d;
    color: #000;

    & span {
      color: #000;
    }
  }

  ${({ isActive }) =>
    isActive &&
    `
    background-color: #00AB4F;
    color: #fff;

    & span {
      color: #fff;
    }
  `}
  padding: 10px;

  & label {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0;
  }

  & span {
    font-size: 12px;
    ${({ isActive }) => (isActive ? 'color: #fff;' : `color: #646e82;`)}
  }
`

export const CardColunaEtapas = styled(Card)<CardProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;

  &:hover {
    background-color: #00ab4f0d;
  }

  ${({ isActive }) =>
    isActive &&
    `
    background-color: #00AB4F0d;
    border: 1px solid #00AB4F;
  `}
  padding: 10px;

  & label {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0;
  }

  & span {
    font-size: 12px;
    color: #646e82;
  }
`

export const ButtonConfigKanban = styled(Button)<{ width?: number }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
  gap: 10px;
  ${({ width }) => width && `width: ${width}px;`}

  &.btn-blue {
    background-color: #00ab4f;
    &:hover {
      background-color: ${darken('#00AB4F', 0.2)};
    }
  }

  &.btn-light {
    background-color: #fff;
    border: 1px solid #646e82;
    color: #1e2534;
    &:hover {
      background-color: ${darken('#fff', 0.2)};
    }
    &.active {
      background-color: #00ab4f;
      color: #fff;
    }
  }
`

export const EtapaIcon = styled.div<{ etapaColor?: string }>`
  width: 12px;
  height: 12px;
  background-color: ${({ etapaColor }) => etapaColor || '#000'};
  border-radius: 50%;
`

export const SubTitulo = styled.label`
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0;
`

export const Info = styled.span`
  font-size: 12px;
  color: #646e82;
  margin-bottom: 10px;
`

export const CardBigNumberSla = styled(Card)<CardProps>`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  ${({ isActive }) =>
    isActive &&
    `
    background-color: #00AB4F;
    color: #fff;

    & span {
      color: #fff;
    }
    `}

  padding: 24px;

  & .title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0;
  }

  & .icon {
    font-size: 20px;
    color: #646e82;
  }

  & .informacao {
    font-size: 24px;
    font-weight: 600;
  }
`

export const CardSLAConfigurado = styled(Card)<CardProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;

  &:hover {
    background-color: #182c9a0d;
  }

  ${({ isActive }) =>
    isActive &&
    `
        background-color: #00AB4F0d;
        border: 1px solid #00AB4F;
      `}
  padding: 10px;

  & .titulo {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 0;
  }

  & .descricao {
    font-size: 12px;
    color: #646e82;
  }

  & .status {
    padding: 4px 12px;
    background-color: #182c9a;
    color: #fff;
    border-radius: 9999px;
    font-size: 12px;
  }

  & .infos {
    font-size: 14px;
    color: #646e82;

    & span {
      color: #1e2534;
    }
  }

  & .icon-trash {
    font-size: 15px;
    color: #e53935;
  }

  & .situacao-verde,
  & .situacao-amarelo,
  & .situacao-vermelho {
    padding: 4px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    gap: 2px;
    min-height: 60px;
    width: 100%;
    font-size: 12px;
    text-align: center;

    & .valor {
      font-size: 16px;
      font-weight: 600;
    }
  }

  & .situacao-verde {
    background-color: #189a641a;
    & .valor {
      color: #189a64;
    }
  }

  & .situacao-amarelo {
    background-color: #e29a1d1a;
    & .valor {
      color: #e29a1d;
    }
  }

  & .situacao-vermelho {
    background-color: #e141411a;
    & .valor {
      color: #e14141;
    }
  }
`

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: center;
  width: 100%;
  overflow: hidden;
`

export const StageBadge = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  color: #fff;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
`

export const MoreBadge = styled.div`
  background-color: #f3f4f6;
  color: #4b5563;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 0.625rem;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
`

export const EtapaGrid = styled.div`
  background-color: #fff;
  border: 1px solid #f3f4f6;
  color: #4b5563;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 0.625rem;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
`
